import {useContext, useEffect, useState} from "react";
import {NotificationConfigListContext} from "../context/notificationConfigList";
import {NotificationConfig} from "../queries/notificationConfig";
import {useKeycloak} from '@react-keycloak/web';
import useToken from "../../../useToken";

export const useNotificationConfigList = () => {
    const {state, dispatch} = useContext(NotificationConfigListContext);
    const [loading, setLoading] = useState(false);
    const {keycloak, initialized} = useKeycloak();
    const {token} = useToken();

    useEffect( () => {
        if (keycloak.authenticated && token) {
            setLoading(true)
            NotificationConfig.findAll()
                .then( config => {
                    
                    dispatch({type: "initNotificationConfigList",payload: config})
                    setLoading(false)
                } ).catch( (e) =>console.log(e, "<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<") )    
        }
    }, [keycloak.authenticated, initialized] );

    return { notificationConfigs: state, loading }
}